import React from "react";

const TotalUserIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="61"
    viewBox="0 0 60 61"
    fill="none"
  >
    <path
      opacity="0.21"
      d="M37 0.5C49.7025 0.5 60 10.7975 60 23.5V37.5C60 50.2025 49.7025 60.5 37 60.5H23C10.2975 60.5 0 50.2025 0 37.5V23.5C0 10.7975 10.2975 0.5 23 0.5H37Z"
      fill="#8280FF"
    />
    <path
      opacity="0.587821"
      d="M38 25.167C40.2091 25.167 42 26.9579 42 29.167C41.9998 31.376 40.209 33.167 38 33.167C35.7911 33.1668 34.0002 31.3759 34 29.167C34 26.958 35.791 25.1672 38 25.167ZM26 18.5C28.9454 18.5 31.3338 20.8876 31.334 23.833C31.334 26.7785 28.9455 29.167 26 29.167C23.0546 29.1668 20.667 26.7784 20.667 23.833C20.6672 20.8877 23.0547 18.5002 26 18.5Z"
      fill="#8280FF"
    />
    <path
      d="M25.9775 31.8333C32.3612 31.8333 37.6062 34.8907 37.9971 41.4329C38.0126 41.6935 37.9967 42.5002 36.9951 42.5002H14.9697C14.6353 42.4998 13.9728 41.7784 14.001 41.4319C14.5179 35.0686 19.6825 31.8333 25.9775 31.8333ZM37.4688 34.5022C42.0104 34.552 45.7188 36.8468 45.998 41.6995C46.0093 41.8949 45.9978 42.5002 45.2744 42.5002H40.1338C40.1338 39.4995 39.1417 36.7303 37.4688 34.5022Z"
      fill="#8280FF"
    />
  </svg>
);

export default TotalUserIcon;
